import './HeroHeading.scss';
import template from './HeroHeading.vhtml';

export default {
	name: 'HeroHeading',
	template: template,
	props: {
		title: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		words: [],
	}),
	computed: {
		wordsWithSpaces() {
			return this.words.map(word => {
				return word + ' ';
			});
		},
	},
	methods: {
		wordDelay(delay) {
			// const indexMod = delay + 1;
			const wait = delay + '00';
			const less = parseInt(wait);
			return less;
		},
	},
	mounted() {
		this.words = this.title.split(' ');
	},
};
